import { BusinessUnitComponent } from '@zola-helpers/client/dist/es/@types';
import { EventConfig } from '@zola/tracking-contracts/src/configs';

export const PAPER_FLOW = 'paper-onboard';
export const PAPER_QUICK_FLOW = 'paper-quick-onboard';
export const PLANNING_V2 = 'wedding-planning-onboard-v2';
export const PLANNING_V1 = 'wedding-planning-onboard';
export const REGISTRY_ONBOARD = 'registry-onboard';
export const WEDDING_QUICK_FLOW = 'wedding-quick-onboard';
export const COMMUNITY_QUICK_FLOW = 'community-quick-onboard';
export const BUDGET_ONBOARD = 'budget-onboard';
export const VENDOR_FAVORITE_QUICK_FLOW = 'vendor-favorite-quick-flow';
export const REAL_WEDDINGS_NONFAVORITE_ONBOARD = 'real-wedding-nonfavorite-onboard';
export const REAL_WEDDINGS_FAVORITE_ONBOARD = 'real-weddings-favorite-onboard';
export const WEDDING_WEBSITE_FLOW = 'wedding-website-onboard';
export const GUEST_LIST_FLOW = 'guest-list-onboard';
export const BOOKED_VENDOR_FLOW = 'booked-vendor-onboard';
export const VENDOR_SAVED_SEARCH_FLOW = 'vendor-saved-search-onboard';

export const BusinessCategoryComponentMap: Record<
  BusinessUnitComponent,
  EventConfig['business_category']
> = {
  BUDGET_TOOL: 'UNATTRIBUTED',
  CHANGE_THE_DATE: 'CHANGE_THE_DATE',
  COMMUNITY: 'UNATTRIBUTED',
  DAY_OF_PAPER: 'DAY_OF',
  DIGITAL_SAVE_THE_DATE: 'DIGITAL_SAVE_THE_DATES',
  HOLIDAY: 'HOLIDAY_CARDS',
  INSPIRATION: 'UNATTRIBUTED',
  INVITATIONS: 'INVITATIONS',
  MARKETPLACE: 'UNATTRIBUTED',
  REGISTRY: 'UNATTRIBUTED',
  SAVE_THE_DATE: 'SAVE_THE_DATES',
  STORE: 'UNATTRIBUTED',
  THANK_YOU_CARDS: 'THANK_YOU',
  WEDDING_ALBUM: 'UNATTRIBUTED',
  WEDDING_CHECKLIST: 'UNATTRIBUTED',
  WEDDING_GUEST_LIST: 'UNATTRIBUTED',
  WEDDING_PLANNING: 'UNATTRIBUTED',
  WEDDING_SHOWER_INVITATION: 'WEDDING_SHOWER_INVITATION',
  WEDDING_WEBSITE: 'UNATTRIBUTED',
  WEDDINGS: 'UNATTRIBUTED',
};
